console.log ('start')

var ur = window.location.href;

if (ur.includes('/product')) {
  $(document).ready(function () {

    // Only add FAQ once
    if ($('.faq-container').length === 0) {

      var faqHtml = ''
        + '<div class="faq-container">'
        +   '<h1 class="lifelongfaq">Help and FAQs</h1>'

        +   '<h2 class="lifelongfaqh2">Shipping</h2>'

        +   '<div class="lifelongfaq-container">'
        +     '<button class="lifelongfaqaccordion">How are orders shipped?<span class="icon">+</span></button>'
        +     '<div class="panel">'
        +       '<p>All orders are shipped via USPS, UPS or FedEx. Standard shipping is FREE for all orders shipping within the United States and will arrive 2-5 business days after your order ships. Express shipping is also available during checkout. A tracking number will be emailed to you as soon as your order ships.</p>'
        +     '</div>'
        +   '</div>'

        +   '<div class="lifelongfaq-container">'
        +     '<button class="lifelongfaqaccordion">Is faster delivery available?<span class="icon">+</span></button>'
        +     '<div class="panel">'
        +       '<p>Yes! Express shipping (1-2 business days) is available for most items. Please select your preferred delivery speed during checkout and a customized shipping quote will be provided.</p>'
        +     '</div>'
        +   '</div>'

        +   '<div class="lifelongfaq-container">'
        +     '<button class="lifelongfaqaccordion">How long will it take for my order to ship?<span class="icon">+</span></button>'
        +     '<div class="panel">'
        +       '<p>We ship Monday through Friday, excluding federal holidays. Most orders ship within 1 business day.</p>'
        +     '</div>'
        +   '</div>'

        +   '<div class="lifelongfaq-container">'
        +     '<button class="lifelongfaqaccordion">Do you ship internationally?<span class="icon">+</span></button>'
        +     '<div class="panel">'
        +       '<p>Yes! We ship worldwide and a customized shipping quote will be provided during checkout based on the shipping address and items on the order.</p>'
        +     '</div>'
        +   '</div>'

        +   '<div class="lifelongfaq-container">'
        +     '<button class="lifelongfaqaccordion">Do you offer gift wrapping or gift boxes? Can I include a gift message?<span class="icon">+</span></button>'
        +     '<div class="panel">'
        +       '<p>All items ship in individual gift boxes. We do not offer a gift "wrapping" service at this time. You can add a "gift message" to your order on the cart page after adding your item to your shopping cart. This message will be printed on the packing slip with the shipment (prices are never included on our packing slips).</p>'
        +     '</div>'
        +   '</div>'

        +   '<h2 class="lifelongfaqh2 faq2">Return Policy / Free Returns</h2>'

        +   '<div class="lifelongfaq-container">'
        +     '<button class="lifelongfaqaccordion">What is your return policy?<span class="icon">+</span></button>'
        +     '<div class="panel">'
        +       '<p>We hope that you love your purchase, but if you are not completely satisfied for any reason, we will gladly accept returns for all products within 90 days of delivery. Simply use our returns portal to generate a free return shipping label for your return or exchange.</p>'
        +     '</div>'
        +   '</div>'

        +   '<div class="lifelongfaq-container">'
        +     '<button class="lifelongfaqaccordion">How do Free Returns work?<span class="icon">+</span></button>'
        +     '<div class="panel">'
        +       '<p>If you aren\'t happy with your purchase for any reason, simply use our returns portal to start your return request and we\'ll provide you with a free return shipping label (within the United States) to return the item to us for a full refund or even exchange.</p>'
        +     '</div>'
        +   '</div>'

        +   '<div class="lifelongfaq-container">'
        +     '<button class="lifelongfaqaccordion">What if my item arrives damaged or defective?<span class="icon">+</span></button>'
        +     '<div class="panel">'
        +       '<p>We\'ll be happy to arrange for a prompt replacement. In most cases, we\'ll have you send the damaged item back to us with a free return shipping label and we\'ll send you a replacement item at no charge. In some instances, such as cracked glass in a picture frame, we may be able to send you a replacement part/piece to avoid having to ship the item back. This choice is always up to the customer and we\'re happy to do whatever it takes to make things right. Simply start your request in our returns portal.</p>'
        +     '</div>'
        +   '</div>'

        + '</div>';

      $('.grid.product-single').append(faqHtml);
    }

    // Accordion behavior
    var acc = document.getElementsByClassName('lifelongfaqaccordion');
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active');

        var panel = this.nextElementSibling;
        var icon = this.querySelector('.icon');

        if (panel.style.display === 'block') {
          panel.style.display = 'none';
          icon.innerHTML = '+';
        } else {
          panel.style.display = 'block';
          icon.innerHTML = '-';
        }
      });
    }

  });
}

console.log ('end')


//Redesign Form

var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
if(window.innerWidth < 768) {
 	
var rev = 0; var timerrev = setInterval(function(){
  if(jQuery('h4.product_brand').length) {
				jQuery('h1.product-single__title').before(jQuery('h4.product_brand'))
                
                jQuery('.product-form').append('<div class="usp-badges--container"> <div class="usp-badges--item"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <mask id="mask0_1_66" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_1_66)"> <path d="M9.99972 33.3334C8.61083 33.3334 7.43027 32.8473 6.45805 31.875C5.48583 30.9028 4.99972 29.7223 4.99972 28.3334H3.33305C2.86083 28.3334 2.46499 28.1736 2.14555 27.8542C1.8261 27.5348 1.66638 27.1389 1.66638 26.6667V10C1.66638 9.08337 1.99277 8.29865 2.64555 7.64587C3.29833 6.99309 4.08305 6.6667 4.99972 6.6667H24.9997C25.9164 6.6667 26.7011 6.99309 27.3539 7.64587C28.0067 8.29865 28.3331 9.08337 28.3331 10V13.3334H31.6664C32.1942 13.3334 32.6942 13.4514 33.1664 13.6875C33.6386 13.9236 34.0275 14.25 34.3331 14.6667L37.9997 19.5417C38.1108 19.6806 38.1942 19.8334 38.2497 20C38.3053 20.1667 38.3331 20.3473 38.3331 20.5417V26.6667C38.3331 27.1389 38.1733 27.5348 37.8539 27.8542C37.5344 28.1736 37.1386 28.3334 36.6664 28.3334H34.9997C34.9997 29.7223 34.5136 30.9028 33.5414 31.875C32.5692 32.8473 31.3886 33.3334 29.9997 33.3334C28.6108 33.3334 27.4303 32.8473 26.4581 31.875C25.4858 30.9028 24.9997 29.7223 24.9997 28.3334H14.9997C14.9997 29.7223 14.5136 30.9028 13.5414 31.875C12.5692 32.8473 11.3886 33.3334 9.99972 33.3334ZM9.99972 30C10.4719 30 10.8678 29.8403 11.1872 29.5209C11.5067 29.2014 11.6664 28.8056 11.6664 28.3334C11.6664 27.8611 11.5067 27.4653 11.1872 27.1459C10.8678 26.8264 10.4719 26.6667 9.99972 26.6667C9.52749 26.6667 9.13166 26.8264 8.81222 27.1459C8.49277 27.4653 8.33305 27.8611 8.33305 28.3334C8.33305 28.8056 8.49277 29.2014 8.81222 29.5209C9.13166 29.8403 9.52749 30 9.99972 30ZM4.99972 25H6.33305C6.80527 24.5 7.34694 24.0973 7.95805 23.7917C8.56916 23.4861 9.24972 23.3334 9.99972 23.3334C10.7497 23.3334 11.4303 23.4861 12.0414 23.7917C12.6525 24.0973 13.1942 24.5 13.6664 25H24.9997V10H4.99972V25ZM29.9997 30C30.4719 30 30.8678 29.8403 31.1872 29.5209C31.5067 29.2014 31.6664 28.8056 31.6664 28.3334C31.6664 27.8611 31.5067 27.4653 31.1872 27.1459C30.8678 26.8264 30.4719 26.6667 29.9997 26.6667C29.5275 26.6667 29.1317 26.8264 28.8122 27.1459C28.4928 27.4653 28.3331 27.8611 28.3331 28.3334C28.3331 28.8056 28.4928 29.2014 28.8122 29.5209C29.1317 29.8403 29.5275 30 29.9997 30ZM28.3331 21.6667H35.4164L31.6664 16.6667H28.3331V21.6667Z" fill="#339999"></path> </g> </svg> <div class="usp-badges--title">Free Shipping</div></div><div class="usp-badges--item"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <mask id="mask0_1_69" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_1_69)"> <path d="M9.99971 36.6667C9.08305 36.6667 8.29833 36.3403 7.64555 35.6875C6.99277 35.0348 6.66638 34.25 6.66638 33.3334V16.6667C6.66638 15.75 6.99277 14.9653 7.64555 14.3125C8.29833 13.6598 9.08305 13.3334 9.99971 13.3334H11.6664V10C11.6664 7.69448 12.4789 5.7292 14.1039 4.1042C15.7289 2.4792 17.6942 1.6667 19.9997 1.6667C22.3053 1.6667 24.2705 2.4792 25.8955 4.1042C27.5205 5.7292 28.333 7.69448 28.333 10V13.3334H29.9997C30.9164 13.3334 31.7011 13.6598 32.3539 14.3125C33.0067 14.9653 33.333 15.75 33.333 16.6667V33.3334C33.333 34.25 33.0067 35.0348 32.3539 35.6875C31.7011 36.3403 30.9164 36.6667 29.9997 36.6667H9.99971ZM9.99971 33.3334H29.9997V16.6667H9.99971V33.3334ZM19.9997 28.3334C20.9164 28.3334 21.7011 28.007 22.3539 27.3542C23.0067 26.7014 23.333 25.9167 23.333 25C23.333 24.0834 23.0067 23.2986 22.3539 22.6459C21.7011 21.9931 20.9164 21.6667 19.9997 21.6667C19.083 21.6667 18.2983 21.9931 17.6455 22.6459C16.9928 23.2986 16.6664 24.0834 16.6664 25C16.6664 25.9167 16.9928 26.7014 17.6455 27.3542C18.2983 28.007 19.083 28.3334 19.9997 28.3334ZM14.9997 13.3334H24.9997V10C24.9997 8.61115 24.5136 7.43059 23.5414 6.45837C22.5692 5.48615 21.3886 5.00004 19.9997 5.00004C18.6108 5.00004 17.4303 5.48615 16.458 6.45837C15.4858 7.43059 14.9997 8.61115 14.9997 10V13.3334Z" fill="#339999"></path> </g> </svg> <div class="usp-badges--title">Safe and Secure Checkout</div></div><div class="usp-badges--item"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <mask id="mask0_1_72" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_1_72)"> <path d="M8.33333 36.6666C7.41667 36.6666 6.63194 36.3402 5.97917 35.6875C5.32639 35.0347 5 34.25 5 33.3333V9.99997C5 9.0833 5.32639 8.29858 5.97917 7.6458C6.63194 6.99302 7.41667 6.66663 8.33333 6.66663H10V4.99996C10 4.52774 10.1597 4.13191 10.4792 3.81246C10.7986 3.49302 11.1944 3.3333 11.6667 3.3333C12.1389 3.3333 12.5347 3.49302 12.8542 3.81246C13.1736 4.13191 13.3333 4.52774 13.3333 4.99996V6.66663H26.6667V4.99996C26.6667 4.52774 26.8264 4.13191 27.1458 3.81246C27.4653 3.49302 27.8611 3.3333 28.3333 3.3333C28.8056 3.3333 29.2014 3.49302 29.5208 3.81246C29.8403 4.13191 30 4.52774 30 4.99996V6.66663H31.6667C32.5833 6.66663 33.3681 6.99302 34.0208 7.6458C34.6736 8.29858 35 9.0833 35 9.99997V18.3333C35 18.8055 34.8403 19.2014 34.5208 19.5208C34.2014 19.8402 33.8056 20 33.3333 20C32.8611 20 32.4653 19.8402 32.1458 19.5208C31.8264 19.2014 31.6667 18.8055 31.6667 18.3333V16.6666H8.33333V33.3333H18.3333C18.8056 33.3333 19.2014 33.493 19.5208 33.8125C19.8403 34.1319 20 34.5277 20 35C20 35.4722 19.8403 35.868 19.5208 36.1875C19.2014 36.5069 18.8056 36.6666 18.3333 36.6666H8.33333ZM31.6667 40C29.8889 40 28.2986 39.5069 26.8958 38.5208C25.4931 37.5347 24.4861 36.25 23.875 34.6666C23.7361 34.3611 23.7708 34.0625 23.9792 33.7708C24.1875 33.4791 24.4583 33.3333 24.7917 33.3333C25.1806 33.3333 25.5347 33.4514 25.8542 33.6875C26.1736 33.9236 26.4306 34.2222 26.625 34.5833C27.125 35.4722 27.8194 36.1805 28.7083 36.7083C29.5972 37.2361 30.5833 37.5 31.6667 37.5C33.2778 37.5 34.6528 36.9305 35.7917 35.7916C36.9306 34.6527 37.5 33.2777 37.5 31.6666C37.5 30.0555 36.9306 28.6805 35.7917 27.5416C34.6528 26.4027 33.2778 25.8333 31.6667 25.8333C30.8611 25.8333 30.1111 25.9791 29.4167 26.2708C28.7222 26.5625 28.1111 26.9722 27.5833 27.5H28.75C29.1111 27.5 29.4097 27.618 29.6458 27.8541C29.8819 28.0902 30 28.3889 30 28.75C30 29.1111 29.8819 29.4097 29.6458 29.6458C29.4097 29.8819 29.1111 30 28.75 30H25C24.5278 30 24.1319 29.8402 23.8125 29.5208C23.4931 29.2014 23.3333 28.8055 23.3333 28.3333V24.5833C23.3333 24.2222 23.4514 23.9236 23.6875 23.6875C23.9236 23.4514 24.2222 23.3333 24.5833 23.3333C24.9444 23.3333 25.2431 23.4514 25.4792 23.6875C25.7153 23.9236 25.8333 24.2222 25.8333 24.5833V25.7083C26.5833 24.9861 27.4583 24.4097 28.4583 23.9791C29.4583 23.5486 30.5278 23.3333 31.6667 23.3333C33.9722 23.3333 35.9375 24.1458 37.5625 25.7708C39.1875 27.3958 40 29.3611 40 31.6666C40 33.9722 39.1875 35.9375 37.5625 37.5625C35.9375 39.1875 33.9722 40 31.6667 40ZM8.33333 13.3333H31.6667V9.99997H8.33333V13.3333Z" fill="#339999"></path> </g> </svg> <div class="usp-badges--title">90 Day Returns</div></div></div>')
                
				var svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <mask id="mask0_1_175" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9"></rect>
                </mask>
                <g mask="url(#mask0_1_175)">
                    <path d="M9.99984 18.3333C8.84706 18.3333 7.76373 18.1146 6.74984 17.6771C5.73595 17.2396 4.854 16.6458 4.104 15.8958C3.354 15.1458 2.76025 14.2639 2.32275 13.25C1.88525 12.2361 1.6665 11.1528 1.6665 10C1.6665 8.84722 1.88525 7.76389 2.32275 6.75C2.76025 5.73611 3.354 4.85417 4.104 4.10417C4.854 3.35417 5.73595 2.76042 6.74984 2.32292C7.76373 1.88542 8.84706 1.66667 9.99984 1.66667C10.9026 1.66667 11.7568 1.79861 12.5623 2.0625C13.3679 2.32639 14.1109 2.69445 14.7915 3.16667L13.5832 4.39583C13.0554 4.0625 12.4929 3.80208 11.8957 3.61458C11.2984 3.42708 10.6665 3.33333 9.99984 3.33333C8.15261 3.33333 6.5797 3.98264 5.28109 5.28125C3.98248 6.57986 3.33317 8.15278 3.33317 10C3.33317 11.8472 3.98248 13.4201 5.28109 14.7187C6.5797 16.0174 8.15261 16.6667 9.99984 16.6667C11.8471 16.6667 13.42 16.0174 14.7186 14.7187C16.0172 13.4201 16.6665 11.8472 16.6665 10C16.6665 9.75 16.6526 9.5 16.6248 9.25C16.5971 9 16.5554 8.75694 16.4998 8.52083L17.854 7.16667C18.0068 7.61111 18.1248 8.06944 18.2082 8.54167C18.2915 9.01389 18.3332 9.5 18.3332 10C18.3332 11.1528 18.1144 12.2361 17.6769 13.25C17.2394 14.2639 16.6457 15.1458 15.8957 15.8958C15.1457 16.6458 14.2637 17.2396 13.2498 17.6771C12.2359 18.1146 11.1526 18.3333 9.99984 18.3333ZM8.83317 13.8333L5.2915 10.2917L6.45817 9.125L8.83317 11.5L17.1665 3.14583L18.3332 4.3125L8.83317 13.8333Z" fill="#1C1B1F"></path>
                </g>
            </svg>`;
            // Replace all instances of ✔️ with the SVG
            $('.product__policies strong, .product__policies p').each(function() {
                var html = $(this).html();
                var newHtml = html.replace(/✔️/g, svg);
                $(this).html(newHtml);
            });
clearInterval(timerrev);}if( rev > 200){clearInterval(timerrev);}rev++;}, 50);
  function updateReviewText() {
            var $span = $('.jdgm-prev-badge__text');
            if (!$span.text().includes("Customer")) {
                var number = parseInt($span.text().replace(/[^\d]/g, ''), 10);
                var reviewText = (number === 1) ? ' Customer Review' : ' Customer Reviews';
                $span.text('(' + number + reviewText + ')' );
            } else {
                clearInterval(intervalId);
            }
        }
        var intervalId = setInterval(updateReviewText, 2000);
}

  
  });
  }

/* quick view on desktop*/

$(document).ready(function(){
  if(window.innerWidth > 769) {
    setInterval(function(){
      var itemcards = $('.spf-col-xl-3');

      for (var i = 0; i < itemcards.length; i++) {
        var $card = $(itemcards[i]);

        // Find or create the container
        var $btnContainer = $card.find('.btn-container');
        if ($btnContainer.length === 0) {
          $btnContainer = $('<div class="btn-container"></div>');
          $card.append($btnContainer);
        }

        // Quick View (always refresh + ensure it's first inside container)
        var $quickView = $('a.open-quick-view').eq(i).html('QUICK VIEW');
        if ($quickView.length) {
          $btnContainer.append($quickView);
        }

        // Learn More (create once if missing)
        var $learnMore = $btnContainer.find('.learn-more-btn').first();
        if ($learnMore.length === 0) {
          var productLink = $card.find('a[href*="/products/"]').not('.learn-more-btn').first().attr('href');
          if (productLink) {
            $learnMore = $('<a>', {
              href: productLink,
              text: 'LEARN MORE',
              class: 'learn-more-btn'
            });
            $btnContainer.append($learnMore);
          }
        }

        // Explicitly enforce order: Quick View then Learn More
        if ($quickView.length && $learnMore.length) {
          $quickView.after($learnMore);
        }
      }
    }, 500);
  }
});







/* quick view popup redesign */

$(document).ready(function() {
  const htmlToPrepend = `
    <div class="product__policies rte" bis_skin_checked="1">
      <strong class="variant-inventory">✔️ In Stock - Ships within 1-2 business days</strong>
      <br>
      <p class="freeshipping"><strong>✔️ Free Shipping from the USA</strong></p>
    </div>
  `;
  const htmlToAppend = `
   <div class="usp-badges--container" bis_skin_checked="1"> <div class="usp-badges--item" bis_skin_checked="1"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <mask id="mask0_1_66" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_1_66)"> <path d="M9.99972 33.3334C8.61083 33.3334 7.43027 32.8473 6.45805 31.875C5.48583 30.9028 4.99972 29.7223 4.99972 28.3334H3.33305C2.86083 28.3334 2.46499 28.1736 2.14555 27.8542C1.8261 27.5348 1.66638 27.1389 1.66638 26.6667V10C1.66638 9.08337 1.99277 8.29865 2.64555 7.64587C3.29833 6.99309 4.08305 6.6667 4.99972 6.6667H24.9997C25.9164 6.6667 26.7011 6.99309 27.3539 7.64587C28.0067 8.29865 28.3331 9.08337 28.3331 10V13.3334H31.6664C32.1942 13.3334 32.6942 13.4514 33.1664 13.6875C33.6386 13.9236 34.0275 14.25 34.3331 14.6667L37.9997 19.5417C38.1108 19.6806 38.1942 19.8334 38.2497 20C38.3053 20.1667 38.3331 20.3473 38.3331 20.5417V26.6667C38.3331 27.1389 38.1733 27.5348 37.8539 27.8542C37.5344 28.1736 37.1386 28.3334 36.6664 28.3334H34.9997C34.9997 29.7223 34.5136 30.9028 33.5414 31.875C32.5692 32.8473 31.3886 33.3334 29.9997 33.3334C28.6108 33.3334 27.4303 32.8473 26.4581 31.875C25.4858 30.9028 24.9997 29.7223 24.9997 28.3334H14.9997C14.9997 29.7223 14.5136 30.9028 13.5414 31.875C12.5692 32.8473 11.3886 33.3334 9.99972 33.3334ZM9.99972 30C10.4719 30 10.8678 29.8403 11.1872 29.5209C11.5067 29.2014 11.6664 28.8056 11.6664 28.3334C11.6664 27.8611 11.5067 27.4653 11.1872 27.1459C10.8678 26.8264 10.4719 26.6667 9.99972 26.6667C9.52749 26.6667 9.13166 26.8264 8.81222 27.1459C8.49277 27.4653 8.33305 27.8611 8.33305 28.3334C8.33305 28.8056 8.49277 29.2014 8.81222 29.5209C9.13166 29.8403 9.52749 30 9.99972 30ZM4.99972 25H6.33305C6.80527 24.5 7.34694 24.0973 7.95805 23.7917C8.56916 23.4861 9.24972 23.3334 9.99972 23.3334C10.7497 23.3334 11.4303 23.4861 12.0414 23.7917C12.6525 24.0973 13.1942 24.5 13.6664 25H24.9997V10H4.99972V25ZM29.9997 30C30.4719 30 30.8678 29.8403 31.1872 29.5209C31.5067 29.2014 31.6664 28.8056 31.6664 28.3334C31.6664 27.8611 31.5067 27.4653 31.1872 27.1459C30.8678 26.8264 30.4719 26.6667 29.9997 26.6667C29.5275 26.6667 29.1317 26.8264 28.8122 27.1459C28.4928 27.4653 28.3331 27.8611 28.3331 28.3334C28.3331 28.8056 28.4928 29.2014 28.8122 29.5209C29.1317 29.8403 29.5275 30 29.9997 30ZM28.3331 21.6667H35.4164L31.6664 16.6667H28.3331V21.6667Z" fill="#339999"></path> </g> </svg> <div class="usp-badges--title" bis_skin_checked="1">Free Shipping</div></div><div class="usp-badges--item" bis_skin_checked="1"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <mask id="mask0_1_69" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_1_69)"> <path d="M9.99971 36.6667C9.08305 36.6667 8.29833 36.3403 7.64555 35.6875C6.99277 35.0348 6.66638 34.25 6.66638 33.3334V16.6667C6.66638 15.75 6.99277 14.9653 7.64555 14.3125C8.29833 13.6598 9.08305 13.3334 9.99971 13.3334H11.6664V10C11.6664 7.69448 12.4789 5.7292 14.1039 4.1042C15.7289 2.4792 17.6942 1.6667 19.9997 1.6667C22.3053 1.6667 24.2705 2.4792 25.8955 4.1042C27.5205 5.7292 28.333 7.69448 28.333 10V13.3334H29.9997C30.9164 13.3334 31.7011 13.6598 32.3539 14.3125C33.0067 14.9653 33.333 15.75 33.333 16.6667V33.3334C33.333 34.25 33.0067 35.0348 32.3539 35.6875C31.7011 36.3403 30.9164 36.6667 29.9997 36.6667H9.99971ZM9.99971 33.3334H29.9997V16.6667H9.99971V33.3334ZM19.9997 28.3334C20.9164 28.3334 21.7011 28.007 22.3539 27.3542C23.0067 26.7014 23.333 25.9167 23.333 25C23.333 24.0834 23.0067 23.2986 22.3539 22.6459C21.7011 21.9931 20.9164 21.6667 19.9997 21.6667C19.083 21.6667 18.2983 21.9931 17.6455 22.6459C16.9928 23.2986 16.6664 24.0834 16.6664 25C16.6664 25.9167 16.9928 26.7014 17.6455 27.3542C18.2983 28.007 19.083 28.3334 19.9997 28.3334ZM14.9997 13.3334H24.9997V10C24.9997 8.61115 24.5136 7.43059 23.5414 6.45837C22.5692 5.48615 21.3886 5.00004 19.9997 5.00004C18.6108 5.00004 17.4303 5.48615 16.458 6.45837C15.4858 7.43059 14.9997 8.61115 14.9997 10V13.3334Z" fill="#339999"></path> </g> </svg> <div class="usp-badges--title" bis_skin_checked="1">Safe and Secure Checkout</div></div><div class="usp-badges--item" bis_skin_checked="1"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <mask id="mask0_1_72" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_1_72)"> <path d="M8.33333 36.6666C7.41667 36.6666 6.63194 36.3402 5.97917 35.6875C5.32639 35.0347 5 34.25 5 33.3333V9.99997C5 9.0833 5.32639 8.29858 5.97917 7.6458C6.63194 6.99302 7.41667 6.66663 8.33333 6.66663H10V4.99996C10 4.52774 10.1597 4.13191 10.4792 3.81246C10.7986 3.49302 11.1944 3.3333 11.6667 3.3333C12.1389 3.3333 12.5347 3.49302 12.8542 3.81246C13.1736 4.13191 13.3333 4.52774 13.3333 4.99996V6.66663H26.6667V4.99996C26.6667 4.52774 26.8264 4.13191 27.1458 3.81246C27.4653 3.49302 27.8611 3.3333 28.3333 3.3333C28.8056 3.3333 29.2014 3.49302 29.5208 3.81246C29.8403 4.13191 30 4.52774 30 4.99996V6.66663H31.6667C32.5833 6.66663 33.3681 6.99302 34.0208 7.6458C34.6736 8.29858 35 9.0833 35 9.99997V18.3333C35 18.8055 34.8403 19.2014 34.5208 19.5208C34.2014 19.8402 33.8056 20 33.3333 20C32.8611 20 32.4653 19.8402 32.1458 19.5208C31.8264 19.2014 31.6667 18.8055 31.6667 18.3333V16.6666H8.33333V33.3333H18.3333C18.8056 33.3333 19.2014 33.493 19.5208 33.8125C19.8403 34.1319 20 34.5277 20 35C20 35.4722 19.8403 35.868 19.5208 36.1875C19.2014 36.5069 18.8056 36.6666 18.3333 36.6666H8.33333ZM31.6667 40C29.8889 40 28.2986 39.5069 26.8958 38.5208C25.4931 37.5347 24.4861 36.25 23.875 34.6666C23.7361 34.3611 23.7708 34.0625 23.9792 33.7708C24.1875 33.4791 24.4583 33.3333 24.7917 33.3333C25.1806 33.3333 25.5347 33.4514 25.8542 33.6875C26.1736 33.9236 26.4306 34.2222 26.625 34.5833C27.125 35.4722 27.8194 36.1805 28.7083 36.7083C29.5972 37.2361 30.5833 37.5 31.6667 37.5C33.2778 37.5 34.6528 36.9305 35.7917 35.7916C36.9306 34.6527 37.5 33.2777 37.5 31.6666C37.5 30.0555 36.9306 28.6805 35.7917 27.5416C34.6528 26.4027 33.2778 25.8333 31.6667 25.8333C30.8611 25.8333 30.1111 25.9791 29.4167 26.2708C28.7222 26.5625 28.1111 26.9722 27.5833 27.5H28.75C29.1111 27.5 29.4097 27.618 29.6458 27.8541C29.8819 28.0902 30 28.3889 30 28.75C30 29.1111 29.8819 29.4097 29.6458 29.6458C29.4097 29.8819 29.1111 30 28.75 30H25C24.5278 30 24.1319 29.8402 23.8125 29.5208C23.4931 29.2014 23.3333 28.8055 23.3333 28.3333V24.5833C23.3333 24.2222 23.4514 23.9236 23.6875 23.6875C23.9236 23.4514 24.2222 23.3333 24.5833 23.3333C24.9444 23.3333 25.2431 23.4514 25.4792 23.6875C25.7153 23.9236 25.8333 24.2222 25.8333 24.5833V25.7083C26.5833 24.9861 27.4583 24.4097 28.4583 23.9791C29.4583 23.5486 30.5278 23.3333 31.6667 23.3333C33.9722 23.3333 35.9375 24.1458 37.5625 25.7708C39.1875 27.3958 40 29.3611 40 31.6666C40 33.9722 39.1875 35.9375 37.5625 37.5625C35.9375 39.1875 33.9722 40 31.6667 40ZM8.33333 13.3333H31.6667V9.99997H8.33333V13.3333Z" fill="#339999"></path> </g> </svg> <div class="usp-badges--title" bis_skin_checked="1">90 Day Returns</div></div></div>
  `;
  setInterval(function() {
    if ($('form.gfqv-product-form .product__policies').length === 0) {
      $('form.gfqv-product-form').prepend(htmlToPrepend);
    }
    if ($('form.gfqv-product-form .usp-badges--container').length === 0) {
      $('form.gfqv-product-form').append(htmlToAppend);
    }
  }, 1000);
});



/* star ratings on mobile */

console.log('star ratings');
$(document).ready(function () {
    const path = window.location.pathname;

    // Check if it's a collections page but not a product page under collections
    if (path.includes("/collections/") && !path.includes("/collections/products/")) {
        if (window.innerWidth <= 768) { // Adjust the width as needed for your mobile breakpoint
            setInterval(function () {
                // Update review text
                let elements = $(".jdgm-prev-badge__text");
                elements.each(function () {
                    let text = $(this).text().replace(/[()]/g, ''); // Remove parentheses
                    let count = parseInt(text); // Convert to an integer
                    if (!isNaN(count)) {
                        let reviewText = count === 1 ? "1 review" : `${count} reviews`;
                        $(this).text(reviewText); // Replace the text
                    }
                });
                // Reposition star ratings
                $(".jdgm-widget.jdgm-preview-badge").each(function () {
                    let $badge = $(this);
                    let $priceWrapper = $badge.closest(".spf-product-card").find(".spf-product-card__price-wrapper");
                    if ($priceWrapper.length > 0) {
                        $badge.insertAfter($priceWrapper); // Move the badge below the price wrapper
                    }
                });
            }, 1000); // Runs every 1000 milliseconds (1 second)
        }
    }
});



/*checkout button cart page*/

$(document).ready(function() {
  if ($(window).width() > 768) { // Only apply on desktop
    $('input[name="checkout"]').attr('value', 'SECURE CHECKOUT');
    $('.new_sticky .cart-stock-note').insertBefore('.cart__footer .cart__shipping.rte');

    // Find the input element by its name attribute
    const $input = $('input[name="checkout"]');

    // Create a new button element with the specified classes
    const $button = $('<button>', {
      type: 'submit',
      name: 'checkout',
      class: 'btn btn--small-wide cart__submit cart__submit-control', // Add classes
      html: 'SECURE CHECKOUT <img src="https://cdn.shopify.com/s/files/1/0081/5713/4884/files/lock_1.png?v=1738262684" alt="Lock Icon" style="width: 20px; height: 20px; margin-left: 8px;">'
    });

    // Replace the input element with the new button
    $input.replaceWith($button);
  }
});



function moveBrandElement() {
    const brand = document.querySelector("h4.product_brand");
    const title = document.querySelector(".product-single__title");
    if (brand && title && title.parentNode) {
      title.parentNode.insertBefore(brand, title);
      return true;
    }
    return false;
  }
  // Wait until both elements exist before running the move
  const interval = setInterval(() => {
    if (moveBrandElement()) {
      clearInterval(interval);
    }
  }, 100); // check every 100ms




//Short About Us Badge
const insertGiftBannerInterval = setInterval(() => {
    const target = $('.easytabs-text').eq(0);
    
    if (target.length && !$('.custom-gift-banner').length) {
      target.after(`
        <div class="custom-gift-banner">
          <h4>Gifts That Are Built to Last</h4>
          <p>At Lifelong Collectibles, we offer high-quality and expertly-crafted pieces to celebrate meaningful moments. Find the perfect, timeless gifts that are built to last.</p>
        </div>
      `);
      clearInterval(insertGiftBannerInterval); // Stop checking once inserted
    }
  }, 300); // Check every 300ms
  const badgeInterval = setInterval(function () {
    const $target = $('.fl_buy');
    if ($target.length && !$target.next('.custom-badges').length) {
      // Hide the original badge section
      $target.find('div[style*="text-align: center"]').hide();
      // New badge HTML using images
      const customBadgesHTML = `
        <div class="custom-badges">
          <div class="llc-about-badge">
            <img src="https://cdn.shopify.com/s/files/1/0081/5713/4884/files/f7_shippingbox-fill.png?v=1749043098" alt="Free Shipping">
            <span>Free Shipping</span>
          </div>
          <div class="llc-about-badge">
            <img src="https://cdn.shopify.com/s/files/1/0081/5713/4884/files/calendar.png?v=1765784991" alt="90-Day Returns">
            <span>90-Day Returns</span>
          </div>
          <div class="llc-about-badge">
            <img src="https://cdn.shopify.com/s/files/1/0081/5713/4884/files/mdi_pencil-ruler.png?v=1749043098" alt="Expertly Crafted">
            <span>Expertly Crafted & Built to Last</span>
          </div>
        </div>
      `;
      // Inject it after the .fl_buy section
      $target.after(customBadgesHTML);
      clearInterval(badgeInterval); // Stop polling
    }
  }, 300); // checks every 300ms







  //product page redesign

  (function() {
  function replaceChecks() {
    var container = document.querySelector(".product__policies");
    if (!container) return;

    // Your custom SVG
    var svgIcon = `
      <span class="custom-stock-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <mask id="mask0_custom" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_custom)">
            <path d="M9 21C7.33333 21 5.91667 20.4167 4.75 19.25C3.58333 18.0833 3 16.6667 3 15V9C3 7.33333 3.58333 5.91667 4.75 4.75C5.91667 3.58333 7.33333 3 9 3H15C16.6667 3 18.0833 3.58333 19.25 4.75C20.4167 5.91667 21 7.33333 21 9V15C21 16.6667 20.4167 18.0833 19.25 19.25C18.0833 20.4167 16.6667 21 15 21H9ZM11 16L17 10L15.6 8.6L11 13.2L8.8 11L7.4 12.4L11 16Z" fill="#612502"/>
          </g>
        </svg>
      </span>`;

    // Keep your existing ✔️ replacement (desktop)
    container.querySelectorAll("strong").forEach(function(el) {
      if (el.textContent.includes("✔️")) {
        el.innerHTML = el.innerHTML.replace(/✔️/g, svgIcon);
      }
    });

    // Mobile-only: replace inline SVGs (skip desktop ✔️ case)
    if (/Mobi|Android/i.test(navigator.userAgent)) {
      container.querySelectorAll("strong svg").forEach(function(el) {
        el.outerHTML = svgIcon;
      });
    }
  }

  // Run immediately, then after a short delay
  replaceChecks();
  setTimeout(replaceChecks, 1500);
})();



(function() {
  // Wait until .custom-badges exists
  var interval = setInterval(function() {
    var badges = document.querySelectorAll('.custom-badges .llc-about-badge img');
    if (badges.length >= 3) {
      clearInterval(interval);

      // Replace images
      badges[0].src = "https://cdn.shopify.com/s/files/1/0081/5713/4884/files/deployed_code.png?v=1758156322";
      badges[1].src = "https://cdn.shopify.com/s/files/1/0081/5713/4884/files/calendar_month.png?v=1758156323";
      badges[2].src = "https://cdn.shopify.com/s/files/1/0081/5713/4884/files/design_services.png?v=1758156322";
    }
  }, 200);
})();



// Cart page checkout button + USP Badges
/* Variation JS */
(function() {
    if (window.innerWidth < 769) return;

    // Configuration
    var targetSelector = '.cart__footer .btn.btn--small-wide.cart__submit.cart__submit-control';
    var badgeClass = 'custom-trust-badges';

    // Define the HTML content
    var trustContent = `
    <div class="${badgeClass}">
        <div class="trust-row">
            <div class="trust-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_11_170" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" fill="#D9D9D9"/></mask>
                  <g mask="url(#mask0_11_170)"><path d="M9 11C8.43333 11 7.95833 10.8083 7.575 10.425C7.19167 10.0417 7 9.56667 7 9V4C7 3.45 7.19167 2.97917 7.575 2.5875C7.95833 2.19583 8.43333 2 9 2H15V11H9ZM17 11V2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V9C22 9.56667 21.8042 10.0417 21.4125 10.425C21.0208 10.8083 20.55 11 20 11H17ZM8 21V13H14.8C15.0333 13 15.2333 13.0667 15.4 13.2C15.5667 13.3333 15.6833 13.4917 15.75 13.675C15.8167 13.8583 15.8292 14.05 15.7875 14.25C15.7458 14.45 15.6333 14.625 15.45 14.775L13.975 16H10V17.5H14.5L18.55 14.15C18.9167 13.8833 19.3042 13.7167 19.7125 13.65C20.1208 13.5833 20.525 13.6 20.925 13.7C21.325 13.8 21.7042 13.9708 22.0625 14.2125C22.4208 14.4542 22.725 14.7667 22.975 15.15L17.1 20.075C16.7333 20.375 16.3333 20.6042 15.9 20.7625C15.4667 20.9208 15.0167 21 14.55 21H8ZM3 22C2.71667 22 2.47917 21.9042 2.2875 21.7125C2.09583 21.5208 2 21.2833 2 21V14C2 13.7167 2.09583 13.4792 2.2875 13.2875C2.47917 13.0958 2.71667 13 3 13H6V21C6 21.2833 5.90417 21.5208 5.7125 21.7125C5.52083 21.9042 5.28333 22 5 22H3Z" fill="#4C2D47"/></g>
                </svg>
            </div>
            <div class="trust-text">Ships within 1-2 business days</div>
        </div>

        <div class="trust-row">
            <div class="trust-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_11_173" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" fill="#D9D9D9"/></mask>
                  <g mask="url(#mask0_11_173)"><path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V12H19V10H5V20H12V22H5ZM19 24C17.7833 24 16.7208 23.6208 15.8125 22.8625C14.9042 22.1042 14.3333 21.15 14.1 20H15.65C15.8667 20.7333 16.2792 21.3333 16.8875 21.8C17.4958 22.2667 18.2 22.5 19 22.5C19.9667 22.5 20.7917 22.1583 21.475 21.475C22.1583 20.7917 22.5 19.9667 22.5 19C22.5 18.0333 22.1583 17.2083 21.475 16.525C20.7917 15.8417 19.9667 15.5 19 15.5C18.5167 15.5 18.0667 15.5875 17.65 15.7625C17.2333 15.9375 16.8667 16.1833 16.55 16.5H18V18H14V14H15.5V15.425C15.95 14.9917 16.475 14.6458 17.075 14.3875C17.675 14.1292 18.3167 14 19 14C20.3833 14 21.5625 14.4875 22.5375 15.4625C23.5125 16.4375 24 17.6167 24 19C24 20.3833 23.5125 21.5625 22.5375 22.5375C21.5625 23.5125 20.3833 24 19 24Z" fill="#4C2D47"/></g>
                </svg>
            </div>
            <div class="trust-text">90-day returns</div>
        </div>

        <div class="trust-row">
            <div class="trust-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_11_176" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" fill="#D9D9D9"/></mask>
                  <g mask="url(#mask0_11_176)"><path d="M10.5 15H13.5L12.925 11.775C13.2583 11.6083 13.5208 11.3667 13.7125 11.05C13.9042 10.7333 14 10.3833 14 10C14 9.45 13.8042 8.97917 13.4125 8.5875C13.0208 8.19583 12.55 8 12 8C11.45 8 10.9792 8.19583 10.5875 8.5875C10.1958 8.97917 10 9.45 10 10C10 10.3833 10.0958 10.7333 10.2875 11.05C10.4792 11.3667 10.7417 11.6083 11.075 11.775L10.5 15ZM12 22C9.68333 21.4167 7.77083 20.0875 6.2625 18.0125C4.75417 15.9375 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.2458 15.9375 17.7375 18.0125C16.2292 20.0875 14.3167 21.4167 12 22Z" fill="#4C2D47"/></g>
                </svg>
            </div>
            <div class="trust-text">Safe and secure checkout</div>
        </div>
    </div>
    `;

    // Start polling: Check every 100ms
    var checkExist = setInterval(function() {
        var targetBtn = document.querySelector(targetSelector);

        if (targetBtn) {
            // Button Found!
            
            // Check if badges already exist (to prevent duplicates)
            var existingBadges = targetBtn.parentNode.querySelector('.' + badgeClass);
            
            if (!existingBadges) {
                // If not there, insert them
                targetBtn.insertAdjacentHTML('afterend', trustContent);
            }
            
            // Clear the interval so it stops running
            clearInterval(checkExist);
        }
    }, 100); 

})();

